import { firebaseAnalyticsEvent } from "../firebase";
import './components.css';

// Images
import CloseIcon from '../images/icons/x.svg';

type Props = {
  type: string,
  name: string,
  url: string,
  thumbnail: string,
  closePreview: () => void
}

export default function Popup({type, name, url, thumbnail, closePreview}: Props) {

  function getAnalytics() {
    firebaseAnalyticsEvent(`wallpaper_${type}`, "Click", name);
    firebaseAnalyticsEvent(`wallpaper - ${name}`, "Click", name);
    window.open(url, "_blank");
  }

  return (
      <div className="popup-container">
        <div className="close">
          <img src={CloseIcon} onClick={closePreview} />
        </div>
        
        <div className="popup-inner">
       
          <h4>{name}</h4>

          <div className="image-container">
            <img src={thumbnail} alt="wallpaper-preview" className="preview-image" />
          </div>

          <button className="white font-1 bold" onClick={getAnalytics}> Download </button>
        </div>
        
        <div className="popup-bg" onClick={closePreview} />
      </div>
    );
}
